import {useEffect, useRef, useState} from "react";
import {Box, Checkbox, TextField as TextFieldMaterial} from "@material-ui/core";
import * as React from "react";
import {useNotify} from "ra-core";
// import get from "lodash/get";
import Button from "@material-ui/core/Button";
import CropFreeIcon from "@material-ui/icons/CropFree";
import * as XLSX from 'xlsx';

import Table from "@material-ui/core/Table";
// import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
// import {Box} from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import {useLocale, useRefresh, useTranslate} from "react-admin";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import {fetchJson as httpClient} from "../utils/keycloak";
import {apiPathConfig, config} from "../utils/config";
// import localeAdapter from "../utils/localeAdapter";
import WindowWidth from "./WindowWidth";
// import {getPromptForTable} from "./CompFormat/utils";

// import GetAppIcon from '@mui/icons-material/GetApp';
import PublishIcon from '@mui/icons-material/Publish';
import HelpIcon from '@mui/icons-material/Help';
import ClearIcon from '@mui/icons-material/Clear';

export const ExcellImpotToBack = (props) => {
    const {
        id,
        type,
        setTableKey
    } = props

    // const notify = useNotify();
    const locale = useLocale();
    const winWith = WindowWidth() - 350
    // const refresh = useRefresh();
    const fileInputRef = useRef(null);

    const translate = useTranslate();

    // const [filePreview, setFilePreview] = useState(null);
    const [form, setForm] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [resultLoad, setResultLoad] = useState(null);
    const [showHelp, setShowHelp] = useState(false);
    const [language, setLanguage] = useState('UA');


    useEffect(() => {
        switch (locale) {
            case 'en':
                setLanguage('EN')
                break
            case 'ru':
                setLanguage('RU')
                break
            case 'uk':
                setLanguage('UA')
                break
            default:
                setLanguage('UA')
                break
        }
    }, [locale]);// eslint-disable-line

    useEffect(() => {
        setTableKey(prev => prev + 1);
    }, [resultLoad]);// eslint-disable-line
    const LoadDialog = props => {

        const {
            setResultLoad,
            resultLoad,
        } = props

        // const translate = useTranslate();
        // const notify = useNotify();

        // console.log('ALARM=====>', resultLoad)

        return (
            <Dialog
                open={resultLoad}
                onClose={(event) => {
                    setResultLoad(null)
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {`${translate('Loading goods')} (${fileName}) ${resultLoad?.loading ? ' --> Loading...' : ''}`}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" style={{width: 480}}>
                        <Box display={'grid'}>
                            <Box display={'flex'}>
                                <b style={{marginRight: 12}}>{translate('Quantity in file')}:</b>{' '}<i>{resultLoad?.count}</i>
                            </Box>
                            {resultLoad?.sku_not_found && resultLoad.sku_not_found.length > 0 &&
                                <>
                                    <Box display={'flex'} style={{color: "red"}}>
                                        <b style={{marginRight: 12}}>{translate('Not found')}:</b>{' '}
                                        <i>{resultLoad?.sku_not_found ? resultLoad?.sku_not_found.length : ''}</i>
                                    </Box>
                                    <Box display={'grid'}>
                                        {resultLoad.sku_not_found.map(it => {
                                            return (
                                                <Box display={'flex'}>
                                                    <i>{it.index + 2}: {it.sku}</i>
                                                </Box>
                                            )
                                        })}

                                    </Box>
                                </>
                            }
                            {resultLoad?.validation_error && resultLoad.validation_error.length > 0 &&
                                <>
                                    <Box display={'flex'} style={{color: "red"}}>
                                        <b style={{marginRight: 12}}>{translate('Validation errors')}:</b>{' '}
                                        <i>{resultLoad?.validation_error ? resultLoad?.validation_error.length : ''}</i>
                                    </Box>
                                    <Box display={'grid'}>
                                        {resultLoad.validation_error.map(it => {
                                            return (
                                                <Box display={'flex'}>
                                                    <Box flex={3}>
                                                        {it?.row
                                                            ? <i>{it.row.index + 2}: {it.row.sku}</i>
                                                            : <i>???</i>
                                                        }
                                                    </Box>
                                                    <Box flex={7}>
                                                        {<i>{it?.error ? it.error[language] : '???'}</i>}
                                                    </Box>
                                                </Box>
                                            )
                                        })}

                                    </Box>
                                </>
                            }
                            {resultLoad?.error &&
                                <Box display={'flex'} style={{color: "red"}}>
                                    <b style={{marginRight: 12}}>Error:</b>{' '}<i>{resultLoad.error}</i>
                                </Box>
                            }
                        </Box>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={(event) => {
                            setResultLoad(null)
                        }}
                        color="primary" autoFocus>
                        CLOSE
                    </Button>
                </DialogActions>
            </Dialog>
        )
    };
    // const [create, {error, data}] = useCreate();
    // const [create, {errorCreate, data: dataCreate}] = useCreate();
    // const [update, {error: errorUpdate, data: dataUpdate}] = useUpdate();
    // const [deleteOne, {error: errorDelete, data: dataDelete}] = useDelete();
    // const { data, isLoading, error, refetch } = useGetOne('dVariantProduct', record.id);

    /* ==================================
    import * as XLSX from 'xlsx';

const sendToBackend = async (base64, fileName) => {
  try {
    const response = await fetch('/api/upload-excel', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        fileName,
        fileData: base64,
      }),
    });

    const data = await response.json();
    console.log('Файл успешно отправлен:', data);
  } catch (error) {
    console.error('Ошибка при отправке файла:', error);
  }
};

const sendToBackend = async (jsonData) => {
  try {
    const response = await fetch('/api/upload-json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ data: jsonData }),
    });

    const result = await response.json();
    console.log('Результат:', result);
  } catch (error) {
    console.error('Ошибка:', error);
  }
};


    ================================== */

    const sendToBackend = async (type) => {
        setResultLoad({
            count: form.result.length,
            loading: true
        })

        // import-products-from-json/{rule_id}
        //ev-services.zenit-auto.com/api/pricing
        try {
            let url = `${config.apiPrices}${'api/pricing/import-products-from-json'}/${id}`;
            const response = await httpClient(`${url}`, {
                method: 'POST',
                // body: JSON.stringify({type: type, data: form.result}),
                body: JSON.stringify(form.result),
            });
            if (response.status >= 200 && response.status <= 300) {
                // console.log('Результат:', response);
                setResultLoad({
                    sku_not_found: response.json.sku_not_found,
                    validation_error: response.json?.validation_error ? response.json.validation_error : [],
                    count: form.result.length,
                    loading: false
                })

                // notify(okRequest, {type: 'success', autoHideDuration: 5000,})
            } else {
                console.log('Результат Error:', response);
                // notify(translate('Error Request'), {type: 'error', autoHideDuration: 5000,});
            }
        } catch (error) {
            console.log('Ошибка:', error?.message);
            setResultLoad({
                ...resultLoad,
                sku_not_found: [],
                validation_error: [],
                error: error?.message,
                count: form.result.length,
                loading: false
            })
        }
    };

    const onFileChangeJson = (event) => {
        const file = event.target.files[0];

        if (file) {
            setFileName(file?.name ? file.name : null)
            // console.log('file======>', file); // Отправка на сервер
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, {type: 'array'});

                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];

                const jsonData = XLSX.utils.sheet_to_json(worksheet, {header: 1});

                // Ожидается, что первая строка — заголовки: ['id', 'name']
                const [headers, ...rows] = jsonData;

                // console.log(headers); // Отправка на сервер
                /*const result = rows.map((row) => ({
                    id: row[0],
                    name: row[1],
                }));*/
                let result = []
                rows.forEach((it, ind) => {
                    let res = {}
                    headers.forEach((it2, ind2) => {
                        res[it2] = it[ind2] !== undefined ? it[ind2] : ''
                    })
                    result.push(res)
                })
                setForm({headers: headers, result: result})
                console.log(result); // Отправка на сервер
                //sendToBackend(result);
            };

            reader.readAsArrayBuffer(file);
            fileInputRef.current.value = '';
        }
    };
    /*const onFileChangeXls = event => {
        // Update the state
        let val;
        let name = event.target.name
        console.log('IMG===========>')
        const file = event.target.files[0];
        if (file && file.type !== undefined) {
            val = file;
            // setSelectedFile(file);
            setFilePreview(URL.createObjectURL(file));
            console.log('IMG===========>', URL.createObjectURL(file))
            const reader = new FileReader();
            reader.onload = () => {
                const base64 = reader.result//.split(',')[1]; // Убираем "data:application/vnd.ms-excel;base64,"
                console.log(file.name, 'base64===========>', base64)
                //sendToBackend(base64, file.name);
            };
            reader.readAsDataURL(file); // Читает как Base64
        }
        setForm(val)
        setFileName(file.name)
    };*/


    // if (config.apiUrl.indexOf('dev-api') < 1) return null
    return (
        <div style={{maxWidth: winWith}}>
            <LoadDialog
                setResultLoad={setResultLoad}
                resultLoad={resultLoad}
            />
            <Box display={'flex'}>
                <Box>
                    <input
                        ref={fileInputRef}
                        hidden={true}
                        type="file"
                        id="fileselect"
                        name="excell"
                        onChange={onFileChangeJson}
                        accept={".xls,.xlsx"}
                        /*accept={"image/gif, image/jpeg, image/png"}*/
                    />
                    <Button
                        onClick={() => {
                            setShowHelp(!showHelp)
                            //document.getElementById('fileselect').click()
                        }}
                        color="primary"
                        startIcon={<HelpIcon/>}
                    >

                    </Button>
                    <Button
                        onClick={() => {
                            document.getElementById('fileselect').click()
                        }}
                        color="primary"
                        startIcon={<CropFreeIcon/>}
                    >
                        {translate('Select file')}
                    </Button>
                </Box>
                {fileName &&
                    <Box ml={2}>
                        <Button
                            title={fileName}
                            onClick={(e) => {
                                sendToBackend(type)
                                // window.location.reload()
                            }}
                            color="primary"
                            startIcon={<PublishIcon/>}
                        >
                            {translate('Download file')} ({form?.result ? form.result.length : ''})
                        </Button>
                    </Box>
                }
                {fileName &&
                    <Box ml={2}>
                        <Button
                            onClick={(e) => {
                                setForm(null)
                                setFileName(null)
                            }}
                            color="primary"
                            startIcon={<ClearIcon/>}
                        >
                            {translate('Clear')}
                        </Button>
                    </Box>
                }
            </Box>
            {showHelp &&
                <Box display={'flex'} hidden={false} mb={1}>
                    <i>Колонки в таблице Excell должны иметь заголовки: <b>sku, discount, bonus_id, use_fix_price, fix_price,
                        currency, order_quantity</b></i>
                </Box>
            }
            {form?.result &&
                <div
                    style={{
                        marginBottom: 8,
                        maxHeight: 250,
                        // maxWidth: winWith,
                        overflowX: "auto",
                        overflowY: "auto",
                        border: '1px solid #ddd'
                    }}
                >
                    <TableContainer style={{width: 'fit-content'}}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{fontWeight: "bold"}} align={'left'}>{'№'}</TableCell>
                                    {form.headers.map((it, index) => {
                                        return (
                                            <TableCell style={{fontWeight: "bold"}} align={'left'}>{it}</TableCell>
                                        )
                                    })
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {form.result.map((it, index) => {
                                    if (index < 300)
                                        return (
                                            <TableRow key={index}>
                                                <TableCell key={-1} align={'left'}>{index + 2}</TableCell>
                                                {form.headers.map((it2, ind2) => {
                                                    return (
                                                        <TableCell key={ind2}
                                                                   align={'left'}>{it[it2]}</TableCell>
                                                    )
                                                })
                                                }

                                            </TableRow>
                                        )
                                })
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            }
        </div>

    )
}

